// AIDEV-NOTE: Jedna definice „neplatný token“ pro `processApiError` (přesměrování rodiče
// a učitele) i slice `invalidToken` (modal studenta). Samostatný soubor bez importů, aby ho
// store mohl použít bez cyklu store ↔ utils/processApiError (ten táhne Sentry a localStorage).
// Backend posílá `Invalid token; email: "…"` (todas-app, abstract_authenticator.py). [TD-460]
export const isInvalidTokenMessage = (errorMessage: string) =>
  errorMessage.toLocaleLowerCase().includes("token verification failed") ||
  errorMessage.toLocaleLowerCase().includes("invalid token") ||
  errorMessage.toLocaleLowerCase().includes("not authenticated");
